export enum PAYMENT_PERMISSION {
  canPayWithCash = 'CASH_PAYMENT',
  canPayWithCard = 'CARD_PAYMENT',
  canPayWithConsumption = 'CONSUMPTION_PAYMENT',
  canPayWithComplement = 'CONSUMPTION_PAYMENT_REDEEM',
  canPayWithAlternative = 'ALTERNATIVE_PAYMENT_METHODS',
  canSplitPaymentInEqualParts = 'SPLIT_EQUAL_PAYMENT',
  canSplitPaymentInProducts = 'SPLIT_PRODUCTS_PAYMENT',
  canSplitPaymentInPartial = 'PARTIAL_PAYMENT',
  canChangePaymentMethod = 'CHANGE_PAYMENT_METHOD',
  canModifyEntryPrice = 'MODIFY_PRODUCT_PRICE',
}